import InputTag from 'vue-input-tag'
import HttpFactory from '@/mixins/http.factory';

import Multiselect from 'vue-multiselect'
//import vSelect from 'vue-select'
//import 'vue-select/dist/vue-select.css';

export default {
	name:'search-issue',
	mixins:[HttpFactory],
	data () {
		return {
			htmlMessage:null,
			data:null,
			jiraProjects:[],
            jiraProjectData:{
                issueTypes:[],
                nodesList:[],
                fieldsList:[],
                usersList:[],
                customFields:[]
            },
			showTags:false,
            searchData:{attachments:[],files:[],fields:[]},
			issuesList:[],
			linkData:{issue:null,reqType:null},
			notifyData:{attachments:[],files:[]},
			zendeskInfo:{credentials:null,user:null,ticket:null,origin:null,app_guid:null,attachments:[]}
		}
	},
	created(){
		this.init();
	},
	beforeDestroy(){
        let _self=this;
        _self.fn().destoryEditorObj();
    },
	methods:{
		init(){
			let _self=this;
			modalClient = ZAFClient.init();
			parentClient=null;
			var count=0;
			modalClient.on('send_data_to_modal', (data) => {
				parentClient = modalClient.instance(data.parentClientGuid)
				_self.zendeskInfo=data;
				count++;
				if(count==1){
					_self.issueFields();
					_self.fn().createHtmlEditor('editor');
					setTimeout(function(){_self.initDropzone(data);},500);
				}
			});
		},
		initDropzone(data){
			const _self=this;
			if(!data || !data.userInfo || !data.userInfo.uploadFiles)return;
			_self.fn().initDropzone('div.dropzone',data.credentials,'devops',function(error,response){
				if(error){
					return;
				}
				_self.notifyData.files=_self.notifyData.files.concat(response);
			});
		},
		removeFile(file){
			const _self=this;
			_self.notifyData.files=_self.notifyData.files.filter(d=>d.id!=file.id);
		},
		initJSTree(jiraProjectData){
			let _self=this;
			if(_self.zendeskInfo && _self.zendeskInfo.userInfo && _self.zendeskInfo.userInfo.allowNodes){
			
				_self.fn().createJSTree('area_jstree',function(selectedObj){
					let selPath=selectedObj.path.replace('\\Area',''); //`${_self.searchData.project.name}\\${selectedObj.text}`;
					selPath=selPath.startsWith('\\')?selPath.substr(1,selPath.length-1):selPath;
					selPath=_self.fn().handleTfsAreaIteration(selPath,'Area',_self.zendeskInfo.userInfo);
					_self.searchData.fields['System.AreaPath']=selPath;

				});
				_self.fn().createJSTree('iterations_jstree',function(selectedObj){
					let selPath=selectedObj.path.replace('\\Iteration','');//`${_self.searchData.project.name}\\${selectedObj.text}`;
					selPath=selPath.startsWith('\\')?selPath.substr(1,selPath.length-1):selPath;
					selPath=_self.fn().handleTfsAreaIteration(selPath,'Iteration',_self.zendeskInfo.userInfo);
					_self.searchData.fields['System.IterationPath']=selPath;
				});

				_self.fn().updateJSTreeData('area_jstree',jiraProjectData.nodesList.value.filter(d=>d.structureType=='area'));
				_self.fn().updateJSTreeData('iterations_jstree',jiraProjectData.nodesList.value.filter(d=>d.structureType=='iteration'));
			}
		},
		initsearchData(data,project){
			let _self=this;
			_self.searchData.fields={};
			_self.searchData.hdTicketId=data.hdTicketId?data.hdTicketId:data.ticket.id;
			_self.searchData.fields['System.TeamProject']=project?project.name:'';
			_self.searchData.fields['System.Title']=data.ticket.subject;
			//console.log('zendesk info',data);
			_self.searchData.fields['Microsoft.VSTS.Common.Priority']=data.ticket.priority>0?data.ticket.priority:_self.handlePrioritySet(data.ticket.priority);
			_self.searchData.fields['System.AssignedTo']='';
			_self.searchData.fields['System.IssueType']='';
			_self.searchData.fields['Microsoft.VSTS.Common.Severity']='';
			_self.searchData.fields['System.Tags']='';
			_self.searchData.fields['System.TagsArr'] =_self.searchData.fields['System.Tags']?_self.searchData.fields['System.Tags'].split(';'):[];
			_self.showTags=true;

			//boolean

		},
		handlePrioritySet(priority){
			let intPriority='';
			switch(priority){
				case 'low':
					intPriority=4;
					break;
				case 'normal':
					intPriority=3;
					break;
				case 'high':
					intPriority=2;
					break;
				case 'urgent':
					intPriority=1;
					break;
			}
			return intPriority;
		},
		issueFields(){
			let _self=this;
			_self.jiraProjectsFn(function(projectsResp){
				let jiraProjects=projectsResp.data.Data.value;
				_self.htmlMessage=projectsResp.data.htmlMessage;
				if(jiraProjects && jiraProjects.length>0){
					_self.searchData.project= jiraProjects[0];
					_self.getJiraProjectData(function(jiraProjectData){
						_self.jiraProjects=jiraProjects;
						_self.fn().showLoader(false);
						setTimeout(function(){_self.initJSTree(jiraProjectData);},1000);
					})
				}
				
			});
		},
		getJiraProjectData(cb){
			let _self=this;
			let project=_self.searchData.project;
			_self.initsearchData(_self.zendeskInfo,project);
			_self.jiraProjectDataFn(project.id,function(data){
				let jiraProjectData=data.data.Data;
				_self.jiraProjectData=jiraProjectData;
				if(cb) cb(jiraProjectData);
				else{
					_self.fn().showLoader(false);
					_self.fn().updateJSTreeData('area_jstree',jiraProjectData.nodesList.value.filter(d=>d.structureType=='area'));
					_self.fn().updateJSTreeData('iterations_jstree',jiraProjectData.nodesList.value.filter(d=>d.structureType=='iteration'));
					//setTimeout(function(){_self.applyDatePicker();},1000);
				}
			},function(err){
				_self.fn().showLoader(false);
				let erroList=[
					'We see your authentication token for the azure jira does not have required permissions.',
					'Can you please create azure jira token as per below article and update the app.',
					'https://support.devopsintegration.io/support/solutions/articles/82000451379-how-to-create-azure-devops-authentication-token-'
				]
				_self.userMsg={show:true,type:'danger',list:erroList};
			});
		},
		async validateForm(reqType){
			this.linkData.reqType=null;
			let isValid=await this.$validator.validateAll();
			
			if(!isValid){
				this.userMsg={show:true,type:'danger',list:[`Please scroll up and fill all required fields.`]}
			}else if(reqType){
				this.linkData.reqType=reqType;
			}
			return isValid;
		},
		//create init
		jiraUsersFn:function(successCb,errorCb){
            var _self=this;
            var url = `jira/users`;
            _self.fn().clearMessage();
			_self.postServerFn(url,null,successCb,errorCb);
        },
        jiraProjectsFn:function(successCb,errorCb){
            var _self=this;
            var url = `jira/projects`;
            _self.fn().clearMessage();
			_self.postServerFn(url,null,successCb,errorCb);
        },
        jiraProjectDataFn:function(projectId,successCb,errorCb){
            var _self=this;
            var url = `jira/projects/${projectId}`;
            _self.fn().clearMessage();
			_self.postServerFn(url,null,successCb,errorCb);
        },
		searchIssueFn(){
			let _self=this;
			_self.fn().clearMessage();
			
			_self.searchData.fields['System.Tags']=_self.searchData.fields['System.TagsArr']?_self.searchData.fields['System.TagsArr'].join(';'):'';
			_self.searchData.fields['System.TeamProject']=_self.searchData.project.name;
			let data={..._self.searchData};
			data.auth=_self.zendeskInfo.credentials;
			data.user=_self.zendeskInfo.user;
			delete data.fields['System.TagsArr'];
			let url=`jira/workitems/search`;
			_self.postServerFn(url,data,function(response){
				_self.fn().showLoader(false);
				if(response.data.Success){
					_self.showTags=false;
					_self.searchData.fields['System.TagsArr']=_self.searchData.fields['System.Tags']?_self.searchData.fields['System.Tags'].split(';'):[];
					setTimeout(function(){_self.showTags=true;},1000);
					if(response.data.Data && response.data.Data.value){
						_self.issuesList=response.data.Data.value;
					}else{
						_self.issuesList=[];
						_self.userMsg={show:true,type:'danger',list:[`No results found in the search`]}
					}
				}
			},function(error){ 
				_self.fn().showLoader(false);
				_self.showTags=false;
				_self.searchData.fields['System.TagsArr']=_self.searchData.fields['System.Tags']?_self.searchData.fields['System.Tags'].split(';'):[];
				setTimeout(function(){_self.showTags=true;},1000);
				_self.commonErrorMsgDisp(error);
			});
		},
		modifySearch(){
			const _self=this;
			_self.fn().clearMessage();
			_self.issuesList=[];
			_self.linkData.issue=null;
		},
		issueLog(){
			let _self=this;
			_self.fn().clearMessage();
			if(!this.isIssueSelected()) return;
			var size={ width: '80vw',height: '100vh'};
			let linkData={hdTicketId:_self.zendeskInfo.ticket.id,issueId:_self.linkData.issue.id};
			_self.zendeskInfo.linkData=linkData;
			let triggerInstance=`issue-log-dialog_zd${linkData.hdTicketId}_wd${linkData.issueId}`;
			let action=`/issue-log?hdTicketId=${linkData.hdTicketId}&issueId=${linkData.issueId}`;
			_self.fn().create_zendesk_modal(action,size,triggerInstance,null,_self.zendeskInfo,function(){
				//_self.getAppData();
			});
		},
		submitReqForm(){
			const _self=this;
			_self.fn().clearMessage();
			if(!this.isIssueSelected()) return;
			if(this.linkData.reqType==1){
				this.notifyIssueFn()
			}

			if(this.linkData.reqType==2){
				this.linkIssueFn();
			}
		},
		isIssueSelected(){
			this.fn().clearMessage();
			if(!this.linkData.issue || !this.linkData.issue.id){
				let userMsg={show:true,type:'danger',list:[`Please select work item #`]}
				this.userMsg=userMsg;
				return false;
			}else{
				return true;
			}
		},
		linkIssueFn(){
			let _self=this;
			_self.fn().clearMessage();

			let data=_self.linkData;
			data.auth=_self.zendeskInfo.credentials;
			data.user=_self.zendeskInfo.user;

			var url=`zendesk/link/${_self.zendeskInfo.ticket.id}/${data.issue.id}`
			_self.post(url,data).then(response=>{
				_self.fn().showLoader(false);
				if(response.data.Success){
					_self.data=response.data.Data;
					_self.sendDataToParent(response.data);
				}else{
					_self.userMsg={show:true,type:'danger',list:[`An error occurred!!! Please try again later...`]}
				}
				
			}).catch(error=>{
				_self.fn().showLoader(false);
				_self.commonErrorMsgDisp(error);
			});
		},
		notifyIssueFn(){
			let _self=this;
			_self.fn().clearMessage();
			let data=_self.notifyData;
			if(_self.editorObj)
            	data.commentText=_self.fn().getHtmlEditorContent();
            
			if(!data.commentText || data.commentText.trim()==''){
				_self.userMsg={show:true,type:'danger',list:[`Please enter the comment description`]}
				return;
			}
			data.auth=_self.zendeskInfo.credentials;
			data.user=_self.zendeskInfo.user;
			data.hdTicketId=_self.zendeskInfo.ticket.id;
			data.issueId=_self.linkData.issue.id;
			
			let project=_self.jiraProjects.find(d=>d.name==_self.linkData.issue.fields['System.TeamProject']);
			data.projectId=project?project.id:_self.searchData.project.id;
			let url=`zendesk/notify/${data.hdTicketId}/${data.issueId}/${data.projectId}`
			_self.post(url,data).then(response=>{
				_self.fn().showLoader(false);
				if(response.data.Success){
					let userMsg={show:true,type:'info',list:[response.data.Data?response.data.Data:`Issue notified Successfully`]}
					_self.userMsg=userMsg;
					_self.fn().clearHtmlEditorContent();
					//_self.closeDialog();
				}else{
					_self.userMsg={show:true,type:'danger',list:[`An error occurred!!! Please try again later...`]}
				}
			}).catch(error=>{
				_self.fn().showLoader(false);
				_self.commonErrorMsgDisp(error);
			});
		},
		closeDialog(){
			modalClient.invoke('destroy');
		},
		sendDataToParent(data){
			parentClient.trigger('receive_data_from_modal', data)
      		modalClient.invoke('destroy');

		},
		postServerFn(url,data,successCb,errorCb){
			let _self=this;
			data=data?data:{};
			data.auth=_self.zendeskInfo.credentials;
			_self.post(url,data).then(response=>{
				if(successCb) successCb(response);
			}).catch(error=>{
				if(errorCb) errorCb(error);
			});
		},
	},
	components:{InputTag,Multiselect}
}

